export const FILTER_ICON_NAME = 'filter';
